/*// import ScrollOut
import ScrollOut from "scroll-out";

// Fade Up Effect Animation on any item with the .fadeinup class
ScrollOut({
    //targets:'.home #full-width-page-wrapper .wp-block-columns',
    //targets:'.fadeinup',
    targets:'.home #full-width-page-wrapper .wp-block-column:has(hr), .home #full-width-page-wrapper .wp-block-columns .wp-block-column:first-child:has(ul)',
    onShown: function(el) {
     // remove the class
     el.classList.remove('animate__animated', 'animate__fadeInUp');
     // force reflow
     void el.offsetWidth;
     // re-add the animated cl
     el.classList.add('animate__animated', 'animate__fadeInUp');
     //el.animate([{ opacity: 0 }, { opacity: 1 }], 1000);
   }
});
// Fade Right Effect Animation on any item with the .fadeinright class
ScrollOut({
    //targets:'.home #full-width-page-wrapper .wp-block-columns',
    //targets:'.fadeinright',
    targets:'.home #full-width-page-wrapper .wp-block-columns .wp-block-column:last-child:has(h2, .wp-block-buttons)',
    onShown: function(el) {
     // remove the class
     el.classList.remove('animate__animated', 'animate__fadeInRight');
     // force reflow
     void el.offsetWidth;
     // re-add the animated cl
     el.classList.add('animate__animated', 'animate__fadeInRight');
   }
});*/
//
import Lightbox from './bs5-lightbox';

const options = {
    keyboard: true
};

document.querySelectorAll('[data-toggle="lightbox"]').forEach((el) => el.addEventListener('click', (e) => {
    e.preventDefault();
    const lightbox = new Lightbox(el, options);
    lightbox.show();
}));
//
// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const swiper = new Swiper('.swiper', {
    // Optional parameters
    //direction: 'vertical',
    modules: [Autoplay, Navigation, Pagination],
    loop: true,
    slidesPerView: 1,
    //breakpoints: {
    //    992: {
    //        slidesPerView: 2,
    //        spaceBetween: 24
    //    }
    //},
    //autoHeight: true, // Make slides equal height
    autoplay: {
        delay: 8000,
    },
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
    },
});
//
// Back to Top Button
// Get the button
var mybutton = document.getElementById("btn-back-to-top");
// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
    scrollFunction();
};
//
function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
    }
    else {
        mybutton.style.display = "none";
    }
}
// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener("click", backToTop);
//
function backToTop() {
    jQuery("html, body").animate({ scrollTop: 0 }, "slow");
}
//
jQuery(document).ready(function ($) {
    $('a[href*="#block-"]').on('click', function (e) {
        // Extract pathname and hash
        const linkPath = this.pathname;
        const linkHost = this.hostname;
        const hash = this.hash; // safe: only #block-donate

        // If same page → smooth scroll
        if (linkPath === window.location.pathname && linkHost === window.location.hostname) {

            e.preventDefault();

            const headerHeight = $('#wrapper-navbar').outerHeight();
            const $target = $(hash);

            if ($target.length) {
                const scrollPos = $target.offset().top - headerHeight;

                $('html, body').animate({
                    scrollTop: scrollPos
                }, 'slow');
            }
        }
    });
    //

    if (window.location.hash && window.location.hash.startsWith('#block-')) {

        const $target = $(window.location.hash);

        if ($target.length) {
            const headerHeight = $('#wrapper-navbar').outerHeight();
            const scrollPos = $target.offset().top - headerHeight;

            $('html, body').animate({
                scrollTop: scrollPos
            }, 'slow', function () {
                // Remove hash from URL after scroll
                history.replaceState(null, null, window.location.pathname + window.location.search);
            });
        }
    }
});

// Add your custom JS here.
(function ($) {

    $('.fadeInUp, .fadeInDown, .fadeInLeft, .fadeInRight, .zoomIn, .icon-section .wp-block-columns, h1, *:not(.wp-block-column) > .wp-block-columns.has-two-children:has(.wp-block-column:first-of-type .wp-block-image):not(:has(.wp-block-column:last-of-type .wp-block-image, .wp-block-column:last-of-type .wp-block-cover)) .wp-block-column:first-of-type:has(.wp-block-image), *:not(.wp-block-column) > .wp-block-columns.has-two-children:has(.wp-block-column:last-of-type .wp-block-image):not(:has(.wp-block-column:first-of-type .wp-block-image, .wp-block-column:first-of-type .wp-block-cover)) .wp-block-column:last-of-type:has(.wp-block-image), .wp-block-button').addClass('hidden');
    //
    function animatedStats() {
        $('.stat').each(function () {
            var minNum, maxNum;
            var $this = $(this);
            var charNum = $this.find('.num strong').text().length;
            if (charNum == 3) {
                minNum = 100;
                maxNum = 999;
            } else if (charNum == 2) {
                minNum = 10;
                maxNum = 99;
            } else if (charNum == 1) {
                minNum = 1;
                maxNum = 9;
            }
            var intrvl = setInterval(numbFunction, 75);
            function numbFunction() {
                if (!$('.animated-stats').hasClass("active")) {
                    //var x = Math.floor((Math.random() * maxNum) + minNum); // Original - incorrect formula
                    var x = Math.floor(Math.random() * (maxNum - minNum + 1) + minNum);
                    $this.find('.num strong').text(x);
                }
                else {
                    $this.find('.num strong').text($this.find('.num').attr('data-num'));
                }
            }
        });
    };
    if (('.animated-stats').length) {
        animatedStats();
    }
    //
    function checkAnimatedStats() {
        if ($('.animated-stats').length) {
            var scroll = $(window).scrollTop();
            var statsBar = $('.animated-stats').offset();

            // Check if it's in view (same as your scroll logic)
            if (scroll + ($(window).height() / 1.3) >= statsBar.top) {
                setTimeout(function () {
                    $('.animated-stats').addClass('active');
                }, 500);
            }
        }
    }
    //
    $(window).on('load', function () {
        // 👇 Run once on page load
        checkAnimatedStats();
        // 👇 Also run every time the user scrolls
        $(window).on('scroll', function () {
            checkAnimatedStats();
        });
    });

})(jQuery);

const parents = document.querySelectorAll('.wp-block-columns');

parents.forEach(parent => {
    const children = parent.children;
    if (children.length === 2) {
        parent.classList.add('has-two-children');
    }
});
//

//Animations
import ScrollOut from "scroll-out";
// Fade in Up
ScrollOut({
    targets: '.fadeInUp, .icon-section .wp-block-columns',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInUp', 'hidden');
        // force reflow
        void el.offsetWidth;
        // re-add the animated class
        el.classList.add('animate__animated', 'animate__fadeInUp');
    },
    once: true
});

// Fade in Down
ScrollOut({
    targets: '.fadeInDown, h1',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInDown', 'hidden');
        // force reflow
        void el.offsetWidth;
        // re-add the animated class
        el.classList.add('animate__animated', 'animate__fadeInDown');
    },
    once: true
});

// Slide in Left
ScrollOut({
    targets: '.fadeInLeft, *:not(.wp-block-column) > .wp-block-columns.has-two-children:has(.wp-block-column:first-of-type .wp-block-image):not(:has(.wp-block-column:last-of-type .wp-block-image, .wp-block-column:last-of-type .wp-block-cover)) .wp-block-column:first-of-type:has(.wp-block-image)',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInLeft', 'hidden');
        // force reflow
        void el.offsetWidth;
        // re-add the animated class
        el.classList.add('animate__animated', 'animate__fadeInLeft');
    },
    once: true
});

// Slide in Right
ScrollOut({
    targets: '.fadeInRight, *:not(.wp-block-column) > .wp-block-columns.has-two-children:has(.wp-block-column:last-of-type .wp-block-image):not(:has(.wp-block-column:first-of-type .wp-block-image, .wp-block-column:first-of-type .wp-block-cover)) .wp-block-column:last-of-type:has(.wp-block-image)',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInRight', 'hidden');
        // force reflow
        void el.offsetWidth;
        // re-add the animated class
        el.classList.add('animate__animated', 'animate__fadeInRight');
    },
    once: true
});

// Zoom Fade In
ScrollOut({
    targets: '.zoomIn, .wp-block-button',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__zoomIn', 'hidden');
        // force reflow
        void el.offsetWidth;
        // re-add the animated class
        el.classList.add('animate__animated', 'animate__zoomIn');
    },
    once: true
});
